<div class="break-point-cover">
  <div class="break-point-wrap">
    <div class="break-point-main">
      <p class="tips">上次学到：</p>
      <p class="content">{{courseName}} — {{courseModule}}</p>
      <div class="btn round solid" (click)="continueLearning()">继续学习</div>
      <div class="btn hollow" (click)="close()" >跳过</div>
    </div>
    <div class="break-point-btn">
<!--      <img src="{{assetsRoute}}/picture/camp/i-right-light.png" alt="">-->
      <img (click)="close()" class="btn" src="../../assets/picture/learningmap/breakPointClose.png" alt="" />
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/app-break-point/app-break-point.component.html